/**
 * Genera una contraseña aleatoria segura.
 * Garantiza al menos un carácter de cada tipo y mezcla el resultado.
 */
export function generateRandomPassword(length = 10): string {
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const specials = '!@#$%^&*()_+-=[]{}|;:,.<>?';
  const all = lower + upper + numbers + specials;

  // Garantizar al menos un carácter de cada tipo
  let password = '';
  password += lower.charAt(Math.floor(Math.random() * lower.length));
  password += upper.charAt(Math.floor(Math.random() * upper.length));
  password += numbers.charAt(Math.floor(Math.random() * numbers.length));
  password += specials.charAt(Math.floor(Math.random() * specials.length));

  // Agregar caracteres aleatorios restantes
  for (let i = 4; i < length; i++) {
    password += all.charAt(Math.floor(Math.random() * all.length));
  }

  // Mezclar usando Fisher-Yates shuffle (más confiable)
  const arr = password.split('');
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }

  return arr.join('');
}
/**
 * Genera un número de ubicación aleatorio de 5 dígitos como string.
 */
export function generateRandomLocation(): string {
  return Math.floor(10000 + Math.random() * 90000).toString();
}

/**
 * Genera un token de confirmación aleatorio (UUID v4 simulado).
 */
export function generateConfirmationToken(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
